import { Component, OnInit, ViewChild,Renderer2, Input, OnDestroy, ComponentFactoryResolver, Injector, ComponentRef, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ExcelService } from 'src/app/shared/services/export-excel/export-excel.service';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TableDeleteModalComponent } from '../table-delete-modal/table-delete-modal.component';
import { first } from 'rxjs/operators';
import { ReportService } from '../../service/report.service';
import { NotifierService } from 'angular-notifier';
import { RepoApiService } from '../../service/repo-api.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
// import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { KpigridComponent } from './kpigrid/kpigrid.component';
import { GridApi } from 'ag-grid-community';


@Component({
  selector: 'app-table-view',
  templateUrl: './table-view.component.html',
  styleUrls: ['./table-view.component.scss']
})
export class TableViewComponent implements OnInit, OnDestroy {
  private eventsSubscription: Subscription;
  public tableRef;
  public isOPenKPIS:boolean = true;
  public downloadElementRef;
  public downloadTableRef;
  public gridData:any = {};
  // public downloadTableData;
  public filterLevels:any = {};
  public kpiKeys:any = [];
  public kpiIdList:any = [];
  public lastOpendKpi:string = '';
  public opendKpi:string[] = [];
  
  public isFirstRowToggeleDone:boolean = true;
  private gridApi!: GridApi;
  
  @Input() events: Observable<void>

  constructor(
    // private cd: ChangeDetectorRef,
    public evService:ExcelViewerService,
    private readonly renderer: Renderer2,
    private excelService: ExcelService,
    public dialoge:MatDialog,
    public reportService: ReportService,
    private repoService:RepoApiService,
    private notifier:NotifierService,
    private sidePanelService:SidePanelService,
    private fResolver: ComponentFactoryResolver,
    // private injector: Injector,
    private viewContainer: ViewContainerRef,
    ) {}

  ngOnInit() {    
    this.evService.excelDataSUb
    .pipe(first())
    .subscribe((value) => {
      setTimeout(()=>{
        if(document.getElementById('tableID')){
          this.isOPenKPIS = true;
          this.initTable();
        }
      },200);
      
    });

    this.eventsSubscription = this.events.subscribe((type) => this.getDownloadType(type));
   

  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
    this.evService.lastKpi = {};
    this.evService.removekpiViewerMerge();
  }

  initTable(){
    this.tableRef = document.getElementById('tableID') as HTMLElement;
    this.renderer.setProperty(this.tableRef, 'innerHTML','');
    // console.log("this.selectedSheet 1 ===>",this.evService.selectedSheet)
    let tableData = this.evService.selectedSheet['value']['kpis'];
    // console.log("tableData ====> ",tableData)
    this.kpiKeys = Object.keys(tableData);
    this.kpiIdList = []
    if (this.kpiKeys.length) {
      this.kpiKeys.forEach(key => {
        this.getAllKpisId(tableData[key]);
        // this.kpiIdList.push(tableData[key]["kpi_id"]);
      });
      this.evService.lastKpi = this.evService.selectedSheet['value']['kpis'][this.kpiKeys[this.kpiKeys.length - 1]]
      this.opendKpi = [];
      this.isFirstRowToggeleDone = true;
      let lastPriority = (this.evService.lastKpi && this.evService.lastKpi.priority != null && this.evService.lastKpi.priority >= 0) ? this.evService.lastKpi.priority : null
      this.convertRecursivly(tableData, this.tableRef, "root","root",lastPriority);
      // this.drawDownloadTable(tableData);
    }
  }

  getAllKpisId(options){
    if(options['type'] === 'level'){
      // this.kpiIdList.push(options['kpi_id']);
      Object.keys(options['options']).forEach((key) =>{
        this.getAllKpisId(options['options'][key]);
      });
      // options['options'].forEach((key) =>{
      //   return this.getAllKpisId(key);
      // })
    }else{
      this.kpiIdList.push(options['kpi_id']);
    }
  }

  copyTable(tableName:string,table_id,payload,parent_id,event,table_obj,priority){
    event.stopPropagation();
    // console.log(table_obj,'CopyTable');
    let group_obj = {};
    group_obj[tableName] = table_obj;
    // let priority = Object.keys(this.evService.selectedSheet['value']['kpis']).length - 1
    let tableData  = {"tableName":tableName,"table_id":table_id,'group_obj':group_obj,"parent_id":parent_id}
    if (priority != null && priority >= 0) {
      tableData["priority"] = priority + 1
    }
    // console.log("tableData ===> ",tableData)
    this.evService.copyTable(tableData)
  }
  editTable(tableName:string,table_id,data,parent_id,event){
    event.stopPropagation();
    let payload = data["payload"];
    // console.log("data ====> ",data)
    this.evService.editTable({"tableName":tableName,"table_id":table_id,"payload":payload,"parent_id":parent_id,"data":data,'is_header':payload['is_header'] ? true : false})
  }
  deleteTable(tableName:string,table_id,payload,parent_id,event,table_obj){
    event.stopPropagation();
    // console.log(table_obj,'CopyTable');
    let group_obj = {};
    group_obj[tableName] = table_obj;
    this.dialoge.open(TableDeleteModalComponent,
    {
      data:{"tableName":tableName,"table_id":table_id,'delete_type':'table',group_obj:group_obj,"parent_id":parent_id},
      height:'140px',width:'400px'
    });
  }

  copyGroup(groupObj,parent_id,event,priority){
    event.stopPropagation();
    //console.log("groupObj ==>",groupObj)
    let groupName = groupObj['parent'].split("$_$-$_$");
    groupName = groupName[groupName.length-1];
    let group_obj = {};
    group_obj[groupName] = groupObj;
    let groupData = {"tableName":groupName,"table_id":groupObj['kpi_id'],'group_obj':group_obj,"parent_id":parent_id}
    if (priority != null && priority >= 0) {
      groupData["priority"] = priority + 1
    }
    // console.log("groupData =>",groupData)
    this.evService.copyGroup(groupData);
  }

  editGroup(groupObj,parent_id,event){
    event.stopPropagation();
    this.evService.isEditGroupToplineComponent = true;
    this.evService.editGroupToplineDetails = groupObj;
  }

  deleteGroup(groupObj,parent_id,event){
    event.stopPropagation();
    // console.log("groupObj ==>",groupObj);
    // let groupName = groupObj['parent'].split("$_$-$_$");
    // groupName = groupName[groupName.length-1];
    let groupName = groupObj['name']
    let group_obj = {};
    group_obj[groupName] = groupObj;
    this.dialoge.open(TableDeleteModalComponent,
    {
      data:{"tableName":groupName,"table_id":groupObj['kpi_id'],delete_type:'group',group_obj:group_obj,"parent_id":parent_id},
      height:'160px',width:'400px'
    });
  }

  toggleRow(toggleIcon:HTMLElement, contentRef:HTMLDivElement, name, data, id?:string){
    const icon = toggleIcon.innerText == 'arrow_drop_up' ? 'arrow_drop_down' : 'arrow_drop_up';
    this.renderer.setProperty(toggleIcon, 'innerHTML','');
    this.renderer.appendChild(toggleIcon, this.renderer.createText(icon));
    if(id){
      let tableRef:HTMLElement = document.getElementById(id);
      if(toggleIcon.innerText == 'arrow_drop_up'){
        tableRef.setAttribute('style','display:block')
        this.showTable(data)
      }else{
        tableRef.setAttribute('style','display:none')
      }
    }else{
      if(toggleIcon.innerText == 'arrow_drop_up'){
        this.renderer.setStyle(contentRef, 'display','block');
        this.showTable(data)
      }else{
        this.renderer.setStyle(contentRef, 'display','none');
      }
    }
    this.isFirstRowToggeleDone = true;
    this.checkOpendKPI(name);
    this.evService.prevHoverElement = {};
  }

  showTable(data){
    let tableContentRef:HTMLDivElement = <HTMLDivElement> document.getElementById("table-"+data["id"]);
    if (tableContentRef) {
      let tableElements = tableContentRef.getElementsByClassName('table');
      if (!(tableElements && tableElements.length)) {
        this.drawTable(tableContentRef,data)
      }
    }
  }

  // openTableReorder(event,parentMap){
  //   event.stopPropagation();
  //   let parents = parentMap.split("$_$-$_$");
  //   parents.splice(0,1);
  //   this.evService.selectedKpiReorder["parents"] = parents;
  //   this.evService.selectedKpiReorder["kpi"] = JSON.parse(JSON.stringify(this.evService.selectedSheet['value']['kpis'][parents[0]]));
  //   this.evService.openKPIReorder();
  // }

  checkOpendKPI(name){
    if (this.kpiKeys.includes(name) && this.isFirstRowToggeleDone) {
      this.isFirstRowToggeleDone = false;
      this.lastOpendKpi = name;
      const index = this.opendKpi.indexOf(name);
      if (index == -1) {
        this.opendKpi.push(name);
      }else{
        this.opendKpi.splice(index, 1);
      }
    }
    this.evService.setdDisableOpenKpiDownload(this.opendKpi.length ? false : true);
  }

  convertRecursivly(data, htmlElmRef:HTMLDivElement, parent:string, parent_id:string, lastPriority:number){
    Object.keys(data).forEach((key, index) =>  {
      if(data[key]['type'] == 'level' && data[key]['options']){
        const rows = this.renderer.createElement('div');
        const rowsContent = this.renderer.createElement('div');
        const titleContainer = this.renderer.createElement('div');
        const rowsToggle = this.renderer.createElement('div');
        const rowsTitle = this.renderer.createElement('div');
        const rowsSubTitle = this.renderer.createElement('div');
        const toggleIcon = this.renderer.createElement('i');
        const rowClass = htmlElmRef.classList.contains('kpis-row-content') ? 'kpis-row-inner' : 'kpis-row';
        this.renderer.addClass(rows, rowClass);
        this.renderer.addClass(rows, `group-${data[key]['kpi_id']}`);
        this.renderer.addClass(titleContainer, 'title-container');
        this.renderer.addClass(rowsTitle, 'kpis-row-title');
        this.renderer.addClass(rowsSubTitle, 'kpis-row-sub-title');
        this.renderer.addClass(rowsToggle, 'row-toggle');
        this.renderer.addClass(toggleIcon, 'material-icons');
        this.renderer.addClass(toggleIcon, 'row-toggle-icon');
        this.renderer.addClass(rowsContent, 'kpis-row-content');
        data[key]['parent'] = parent +"$_$-$_$"+key;
        data[key]['parent_id'] = parent_id +"$_$-$_$"+data[key]['kpi_id'];
        if(index == 0 && this.isOPenKPIS && this.evService.kpiParentId.length < 2){
          this.renderer.setStyle(rowsContent, 'display','block');
          this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_up'));
          this.checkOpendKPI(key);
        }else{
          this.renderer.setStyle(rowsContent, 'display','none');
          this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_down'));
        }
        this.renderer.appendChild(rowsTitle, this.renderer.createText(data[key]['name'] + '- (KPIS: '+Object.keys(data[key]['options']).length+')'));
        // this.renderer.appendChild(rowsTitle, this.renderer.createText(key + '- (KPIS: '+Object.keys(data[key]['options']).length+')'));
        this.renderer.appendChild(rowsSubTitle, this.renderer.createText(data[key]['text'] ? data[key]['text'].join(', ') : ''));
        this.renderer.listen(titleContainer, 'click', () => { this.toggleRow(toggleIcon, rowsContent, key, data[key]) }); 
        // console.log("this.evService.isdataTableToplineMapFound",this.evService.isdataTableToplineMapFound)
        if (this.evService.isdataTableToplineMapFound) {
          const copyIcon = this.renderer.createElement('i');
          const editIcon = this.renderer.createElement('i');
          const deleteIcon = this.renderer.createElement('i');
          this.renderer.addClass(copyIcon, 'material-icons');
          this.renderer.addClass(copyIcon, 'material-icons-size-15');
          this.renderer.addClass(editIcon, 'material-icons');
          this.renderer.addClass(editIcon, 'material-icons-size-15');
          this.renderer.addClass(deleteIcon, 'material-icons');
          this.renderer.addClass(deleteIcon, 'material-icons-size-15');
          this.renderer.appendChild(copyIcon, this.renderer.createText('content_copy'));
          this.renderer.appendChild(editIcon, this.renderer.createText('edit'));
          this.renderer.appendChild(deleteIcon, this.renderer.createText('delete_forever'));
          // this.renderer.listen(toggleIcon, 'click', () => { this.toggleRow(toggleIcon, rowsContent, key) });
          // console.log("data",data[key])
          // if (data[key]["original_name"] && data[key]["original_name"] !="") {
            
            this.renderer.listen(copyIcon, 'click', (event) => { this.copyGroup(data[key],data[key]['parent_id'],event,lastPriority) });
            this.renderer.listen(editIcon, 'click', (event) => { this.editGroup(data[key],data[key]['parent_id'],event) });
            this.renderer.listen(deleteIcon, 'click', (event) => { this.deleteGroup(data[key],data[key]['parent_id'],event) });
            this.renderer.appendChild(rowsToggle, editIcon);
            this.renderer.appendChild(rowsToggle, copyIcon);
            this.renderer.appendChild(rowsToggle, deleteIcon);
          // }
        }
        this.renderer.appendChild(rows, titleContainer);
        this.renderer.appendChild(rowsTitle, rowsSubTitle);
        this.renderer.appendChild(titleContainer, rowsTitle);
        this.renderer.appendChild(rowsToggle, toggleIcon);
        this.renderer.appendChild(titleContainer, rowsToggle);
        this.renderer.appendChild(rows, rowsContent);
        this.renderer.appendChild(htmlElmRef, rows);
        // console.log(data[key]['kpi_id'],this.evService.kpiParentId,'Great');
        if(this.evService.kpiParentId.includes(data[key]['kpi_id']+'')){
          this.toggleRow(toggleIcon, rowsContent, key, data[key]);
          let ele = document.querySelector(`.group-${data[key]['kpi_id']}`);
          console.log(ele.className);
          ele.scrollIntoView({block:'start'});
        }
        let keysInGroup = Object.keys(data[key]['options'])
        let lastPriorityInGroup = (data[key]['options'][keysInGroup.length - 1] && data[key]['options'][keysInGroup.length - 1].priority !=null && data[key]['options'][keysInGroup.length - 1].priority >= 0)?data[key]['options'][keysInGroup.length - 1].priority:null
        this.convertRecursivly(data[key]['options'], rowsContent, data[key]['parent'],data[key]['parent_id'],lastPriorityInGroup);
      }else{
        const rows = this.renderer.createElement('div');
        const titleContainer = this.renderer.createElement('div');
        const rowsToggle = this.renderer.createElement('div');
        const rowsTitle = this.renderer.createElement('div');
        const rowsSubTitle = this.renderer.createElement('div');
        const toggleIcon = this.renderer.createElement('i');
        const rowsContent = this.renderer.createElement('div');
        this.renderer.addClass(titleContainer, 'title-container');
        this.renderer.addClass(rowsTitle, 'kpis-row-title');
        this.renderer.addClass(rowsSubTitle, 'kpis-row-sub-title');
        this.renderer.addClass(rowsToggle, 'row-toggle');
        this.renderer.addClass(toggleIcon, 'material-icons');
        this.renderer.addClass(toggleIcon, 'row-toggle-icon');
        this.renderer.addClass(rowsContent, 'kpis-row-inner-content');
        this.renderer.addClass(rows, 'kpis-row-inner');
        data[key]['parent'] = parent +"$_$-$_$"+key;
        data[key]['parent_id'] = parent_id +"$_$-$_$"+data[key]['kpi_id'];
        this.renderer.appendChild(rowsSubTitle, this.renderer.createText(data[key]['text'] ? data[key]['text'].join(', ') : ''));
        const kpisCount = data[key]['type'] == 'level' ? data[key]['name'] + '- ( KPIS: '+Object.keys(data[key]['options']).length+')' : data[key]['name'];
        this.renderer.appendChild(rowsTitle, this.renderer.createText(kpisCount));
        if (this.evService.currentTableId && this.isOPenKPIS  && this.kpiIdList.includes(this.evService.currentTableId)) {
          if (this.evService.currentTableId == data[key]['kpi_id']) {
            // console.log("this.evService.currentTableId ==>",this.evService.currentTableId)
            // console.log("this.kpiIdList ==>",this.kpiIdList)
            // console.log("this.kpiIdList.includes(this.evService.currentTableId) ==>",this.kpiIdList.includes(this.evService.currentTableId))
            this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_up'));
            this.checkOpendKPI(key);
          }else{
            this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_down'));
          }
        }else{
          if(index == 0 && this.isOPenKPIS){
            // console.log("this.evService.currentTableId ==>",this.evService.currentTableId)
            // console.log("this.kpiIdList ==>",this.kpiIdList)
            // console.log("this.kpiIdList.includes(this.evService.currentTableId) ==>",this.kpiIdList.includes(this.evService.currentTableId))
            this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_up'));
            this.checkOpendKPI(key);
          }else{
            this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_down'));
          }
        } 
        // this.renderer.appendChild(toggleIcon, this.renderer.createText('arrow_drop_down'));
        // 
        this.renderer.listen(titleContainer, 'click', () => { this.toggleRow(toggleIcon, rowsContent, key, data[key], data[key]['id']) });
          if (this.evService.isdataTableToplineMapFound) {
            const copyIcon = this.renderer.createElement('i');
            // const reorderIcon = this.renderer.createElement('img');
            const editIcon = this.renderer.createElement('i');
            const deleteIcon = this.renderer.createElement('i');
            this.renderer.addClass(copyIcon, 'material-icons');
            this.renderer.addClass(copyIcon, 'material-icons-size-15');
            // this.renderer.addClass(reorderIcon, 'reorder-icon');
            // this.renderer.addClass(reorderIcon, 'img-icon-size-15');
            this.renderer.addClass(editIcon, 'material-icons');
            this.renderer.addClass(editIcon, 'material-icons-size-15');
            this.renderer.addClass(deleteIcon, 'material-icons');
            this.renderer.addClass(deleteIcon, 'material-icons-size-15');
            this.renderer.appendChild(copyIcon, this.renderer.createText('content_copy'));
            this.renderer.appendChild(editIcon, this.renderer.createText('edit'));
            if(data[key] && data[key]['is_merged']){
              this.renderer.setAttribute(editIcon,'style','display:none');
            }
            this.renderer.appendChild(deleteIcon, this.renderer.createText('delete_forever'));
            // this.renderer.setProperty(reorderIcon,'src', '../../../../assets/repository/icons/move.png');
            if (data[key]["original_name"] && data[key]["original_name"] !="") {
              let tableName =data[key]["original_name"];
              tableName = tableName.replace("original_","");
              // this.renderer.listen(reorderIcon, 'click', (event) => { this.openTableReorder(event,data[key]['parent']) });
              // this.renderer.appendChild(rowsToggle, reorderIcon);
              this.renderer.listen(copyIcon, 'click', (event) => { this.copyTable(tableName,data[key]["kpi_id"],data[key]["payload"],data[key]['parent_id'],event,data[key],lastPriority) });
              this.renderer.listen(editIcon, 'click', (event) => { this.editTable(tableName,data[key]["kpi_id"],data[key],data[key]['parent_id'],event) });
              this.renderer.listen(deleteIcon, 'click', (event) => { this.deleteTable(tableName,data[key]["kpi_id"],data[key]["payload"],data[key]['parent_id'],event,data[key]) });
              if (this.evService.accessRoles && this.evService.accessRoles.repository && this.evService.accessRoles.repository.topline && this.evService.accessRoles.repository.topline.update) {
                this.renderer.appendChild(rowsToggle, editIcon);
              }
              if (this.evService.accessRoles && this.evService.accessRoles.repository && this.evService.accessRoles.repository.topline && this.evService.accessRoles.repository.topline.copy) {
                this.renderer.appendChild(rowsToggle, copyIcon);
              }
              if (this.evService.accessRoles && this.evService.accessRoles.repository && this.evService.accessRoles.repository.topline && this.evService.accessRoles.repository.topline.delete) {
                this.renderer.appendChild(rowsToggle, deleteIcon);
              }
            }
          }
        this.renderer.appendChild(rows, titleContainer);
        this.renderer.appendChild(rowsTitle, rowsSubTitle);
        this.renderer.appendChild(titleContainer, rowsTitle);
        this.renderer.appendChild(rowsToggle, toggleIcon);
        this.renderer.appendChild(titleContainer, rowsToggle);
        this.renderer.appendChild(rows, rowsContent);
        this.renderer.appendChild(htmlElmRef, rows);
      }

      if(data[key]['type'] == 'option' || !data[key]['options']){
        const rowTable = this.renderer.createElement('div');
        const tabletitle = this.renderer.createElement('div');
        const tableContent = this.renderer.createElement('div');
        this.renderer.addClass(rowTable, 'kpis-row-inner-table');
        this.renderer.addClass(tabletitle, 'kpis-row-inner-table-title');
        this.renderer.setProperty(tableContent,'id', 'table-'+data[key]['id']);
        // let id:any = key;
        // id = id.replaceAll(' ', '_');
        this.renderer.setProperty(rowTable, 'id', data[key]['id']);
        this.renderer.appendChild(rowTable, tabletitle);
        this.renderer.appendChild(rowTable, tableContent);
        this.renderer.appendChild(htmlElmRef, rowTable);
    
        if (this.evService.currentTableId && this.isOPenKPIS && this.kpiIdList.includes(this.evService.currentTableId)) {
          if (this.evService.currentTableId == data[key]['kpi_id']) {
            // console.log('if table === KPIID');
            this.renderer.setStyle(rowTable, 'display','block');
            this.isOPenKPIS = false;
            var element = document.getElementById(`table-${data[key]['id']}`);
            this.drawTable(tableContent,data[key]);
            element.scrollIntoView({block: "start" });
            this.evService.setCurrentTableId(null)
            this.checkOpendKPI(key);
          }else{
            this.renderer.setStyle(rowTable, 'display','none');
          }
        }else{
          if(index == 0 && this.isOPenKPIS){
            this.renderer.setStyle(rowTable, 'display','block');
            this.isOPenKPIS = false;
            this.drawTable(tableContent,data[key]);
            this.evService.setCurrentTableId(null)
            this.checkOpendKPI(key);
          }else{
            this.renderer.setStyle(rowTable, 'display','none');
          }
        } 
        // this.drawTable(tableContent,data[key]);
        return;
      }
    });
  }

  drawTable(elmRef:HTMLDivElement, data:any){
    const Table = this.renderer.createElement('div');
    this.renderer.addClass(Table, 'table');
    const kpiFactory = this.fResolver.resolveComponentFactory(KpigridComponent);
    const kpiRef = this.viewContainer.createComponent(kpiFactory);
    let parents = data.parent.split("$_$-$_$");
    parents.splice(0,1);
    // console.log('selectKpi',this.evService.selectedSheet);
    kpiRef.instance.kpi = {
      "header":this.evService.selectedSheet['value']['filters'],
      "rows":data['options']['rows'],
      "data":data['options']['data'],
      "kpiDetails":{"parents":parents,"kpi":JSON.parse(JSON.stringify(data))}
    };
    this.evService.setChildComponent(kpiRef.instance);
    if(data && data['payload'] && data['payload']['merge'] && data['payload']['merge'].length){
      this.evService.kpiViewerMerge = data['payload']['merge'];
    }
    const kpiGrid = kpiRef.location.nativeElement.firstChild;

    this.renderer.appendChild(Table, kpiGrid);
    this.renderer.appendChild(elmRef, Table);
  }

  // drawTable(elmRef:HTMLDivElement, data:any){
  //   data["options"]["rows"].forEach((item, index) => {
  //     item["index"] = index;
  //     if (!(item.priority >=0)) {
  //       item["priority"] = index;
  //     }
  //   });
  //   data["options"]["rows"].sort((a,b) => { return a.priority > b.priority ? 1 : -1});
  //   // console.log("data in drow table",data)
  //   const Table = this.renderer.createElement('div');
  //   this.renderer.addClass(Table, 'table');
  //   const THead = this.renderer.createElement('div');
  //   this.renderer.addClass(THead, 'thead');

  //   // way of inner html
  //   // const TbodyWrapper = this.renderer.createElement('div');
  //   // this.renderer.setProperty(TbodyWrapper, 'innerHTML','<div cdkDropList id="'+data['original_name']+'" (cdkDropListDropped)="drop($event)"></div>');
  //   // const Tbody = TbodyWrapper.firstChild;
  //   // this.renderer.appendChild(TbodyWrapper, Tbody);
  //   // this.renderer.appendChild(Table, TbodyWrapper);


  //   // normal way
  //   const Tbody = this.renderer.createElement('div');

  //   // way of component reference
  //   // const cf = this.fResolver.resolveComponentFactory(TbodyComponent);
  //   // const tBodyRef: ComponentRef<TbodyComponent> = cf.create(this.injector);
  //   // tBodyRef.instance.kpi = data['original_name'].replace('original_','');
  //   // const Tbody = tBodyRef.location.nativeElement.firstChild
   

  //   this.renderer.addClass(Tbody, 'tBody');
  //   this.renderer.appendChild(Table, THead);
  //   this.renderer.appendChild(Table, Tbody);
  //   this.renderer.appendChild(elmRef, Table);
    
  //   this.drawHeaders(THead, this.evService.selectedSheet['value']['filters'], data['mergecols']);

  //   data['options']['rows'].forEach((row, rindex) => {

  //     // way of component reference
  //     // const trFactory = this.fResolver.resolveComponentFactory(TrowComponent);
  //     // const tRowRef: ComponentRef<TrowComponent> = trFactory.create(this.injector);
  //     // const TrowWrapper = tRowRef.location.nativeElement.firstChild;


  //     // way of inner html
  //     // const tRowRef = this.renderer.createElement('div');
  //     // this.renderer.setProperty(tRowRef, 'innerHTML','<div cdkDrag ></div>');
  //     // const TrowWrapper = tRowRef.firstChild;

  //     // console.log("tRowRef.location.nativeElement.firstChild",tRowRef.location.nativeElement.firstChild)
  //     // const Trow = TrowWrapper.firstChild;

  //     const Trow = this.renderer.createElement('div');
  //     this.renderer.setStyle(Trow, 'grid-template-columns', 'minmax(120px, 2fr) repeat(' + (data['options']['data'].length) + ', minmax(60px, 1fr))');
  //     this.renderer.addClass(Trow, 'trow');
  //     // this.renderer.appendChild(TrowWrapper, Trow);
  //     // this.renderer.appendChild(Tbody, TrowWrapper);
  //     this.renderer.appendChild(Tbody, Trow);
  //     const Tcell = this.renderer.createElement('div');
  //     this.renderer.appendChild(Tcell, this.renderer.createText(row['v']));
  //     this.renderer.addClass(Tcell, 'tHeadcell');
  //     this.renderer.setStyle(Tcell, 'background', '#fff');
  //     // this.renderer.setStyle(Tcell, 'background', (row['color'] ? row['color'] : '#fff'));
  //     this.renderer.appendChild(Trow, Tcell);

  //     data['options']['data'].forEach(cell => {
  //       const Tcell = this.renderer.createElement('div');
  //       this.renderer.appendChild(Tcell, this.renderer.createText(cell[row["index"]]['v']));
  //       // this.renderer.appendChild(Tcell, this.renderer.createText(cell[rindex]['v']));
  //       this.renderer.setStyle(Tcell, 'background', (cell[rindex]['color'] ? cell[rindex]['color'] : '#fff'));
  //       this.renderer.addClass(Tcell, 'tcell');
  //       this.renderer.appendChild(Trow, Tcell);
  //     })
  //   })    
  // }

  drawHeaders(elmRef:HTMLDivElement, data:any, length:number){
    
    const Hrow = this.renderer.createElement('div');
    const empty = this.renderer.createElement('div');
    this.renderer.appendChild(elmRef, Hrow);
    this.renderer.addClass(Hrow, 'tRowHead');
    this.renderer.addClass(empty, 'HcellTitle');
    this.renderer.addClass(empty, 'empty');
    let rowCellLength = '';
    if(elmRef.classList.contains('thead')){
      this.renderer.appendChild(Hrow, empty);
      rowCellLength = 'minmax(120px, 2fr) ';
    }
    Object.keys(data).forEach(key =>  {
      if(data[key]['type'] == 'level' && data[key]['options']){
        rowCellLength = rowCellLength + 'minmax(' + ((data[key]['mergecols'] + 1) * 60.9) + 'px, '+ (data[key]['mergecols'] + 1) +'fr)';
        this.renderer.setStyle(Hrow, 'grid-template-columns', rowCellLength);
        const Hcell = this.renderer.createElement('div');
        const HcellTitle = this.renderer.createElement('div');
        const HcellCont = this.renderer.createElement('div');
        this.renderer.addClass(HcellCont, 'checkFor');
        this.renderer.addClass(HcellTitle, 'HcellTitle');
        this.renderer.addClass(Hcell, 'hCell');
        this.renderer.appendChild(Hrow, Hcell);
        this.renderer.appendChild(Hcell, HcellTitle);
        this.renderer.appendChild(HcellTitle, this.renderer.createText(key));
        this.renderer.appendChild(Hcell, HcellCont);
        this.drawHeaders(HcellCont, data[key]['options'], data[key]['mergecols']);
      }
      
      if(data[key]['type'] == 'option' || !data[key]['options']){
        const Hcell = this.renderer.createElement('div');
        this.renderer.addClass(elmRef, 'trow');
        let rowCellLength = '';
        rowCellLength = rowCellLength + 'repeat(' + (length + 1) + ', minmax(60px, 1fr))';
        this.renderer.setStyle(Hrow, 'grid-template-columns', rowCellLength);
        this.renderer.appendChild(Hrow, Hcell);
        this.renderer.addClass(Hcell, 'HcellTitle');
        this.renderer.appendChild(Hcell, this.renderer.createText(key));
        this.renderer.appendChild(elmRef, Hrow);
      }

    });
  }


  drawDownloadTable(tableData){
    this.downloadElementRef = document.getElementById('downloadTableID') as HTMLElement;
    this.renderer.setProperty(this.downloadElementRef, 'innerHTML','');
    this.filterLevels = {};
    // console.log('original data levels ',this.evService.selectedSheet['value']['filters'])
    this.levelTraverser(this.evService.selectedSheet['value']['filters'],1);

    Object.keys(this.filterLevels).forEach(element => {
        let item = this.filterLevels[element]
        if(item && item.length > 0 && element != 'option'){
            let option_counter = 0;
            item.forEach(it => {
                if(it.type == 'option'){
                    option_counter++;
                } 
            });
            if(option_counter == item.length){
                delete this.filterLevels[element];
            }
        }
    });
    let length = Object.keys(this.filterLevels).length;
    this.filterLevels["level "+length] = [];
    this.filterLevels["level "+length] = this.filterLevels['option']
    delete this.filterLevels['option']
    // console.log("filterLevels is ",this.filterLevels);


    
    this.renderer.setStyle(this.downloadElementRef, 'visibility', 'hidden');
    this.renderer.setStyle(this.downloadElementRef, 'height', '0px');
    this.downloadTableRef = this.renderer.createElement('table');
    this.renderer.appendChild(this.downloadElementRef, this.downloadTableRef);
    this.convertRecursivlyDownload(tableData, this.downloadTableRef);
    // console.log("tableData is ",tableData)
  }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
  convertRecursivlyDownload(data, htmlElmRef:HTMLElement){
    Object.keys(data).forEach(key =>  {
      
      if(data[key]['type'] == 'level' && data[key]['options']){
        const tablerow = this.renderer.createElement('tr');
        const tablehead = this.renderer.createElement('th');
        this.renderer.appendChild(tablehead, this.renderer.createText(key));
        this.renderer.appendChild(htmlElmRef, tablerow);
        this.renderer.appendChild(tablerow, tablehead);
        if (data[key].text && data[key].text.length) {
          const textrow = this.renderer.createElement('tr');
          const texthead = this.renderer.createElement('th');
          this.renderer.appendChild(texthead, this.renderer.createText(data[key].text[0]));
          this.renderer.appendChild(htmlElmRef, textrow);
          this.renderer.appendChild(textrow, texthead);
        }
        this.renderer.setAttribute(tablehead, 'colspan','10');
        this.renderer.setAttribute(tablehead, 'rowspan','1');
        this.convertRecursivlyDownload(data[key]['options'], htmlElmRef);
      }else{
        const tablerow = this.renderer.createElement('tr');
        const emptyrow = this.renderer.createElement('tr');
        const tablehead = this.renderer.createElement('th');
        this.renderer.setAttribute(tablehead, 'colspan','10');
        this.renderer.setAttribute(tablehead, 'rowspan','1');
        this.renderer.appendChild(tablehead, this.renderer.createText(key));
        this.renderer.appendChild(htmlElmRef, tablerow);
        this.renderer.appendChild(htmlElmRef, emptyrow);
        this.renderer.appendChild(tablerow, tablehead);
      }

      if(data[key]['type'] == 'option' || !data[key]['options']){
        this.drawDownloadTableData(htmlElmRef,data[key]);
        return;
      }
      
    });
  }

  drawDownloadTableData(elmRef:HTMLElement, data:any){
    const tableHead = this.renderer.createElement('thead');
    // const tableHead = this.renderer.createElement('tr');
    const tableBody= this.renderer.createElement('tbody');
    this.renderer.appendChild(elmRef, tableHead);
    this.renderer.appendChild(elmRef, tableBody);
    this.renderer.setProperty(tableHead, 'innerHTML','');
    // this.drawDownloadTableHeaders(tableHead, this.evService.selectedSheet['value']['filters'], data['mergecols']);
    this.drawDownloadTableHeaders(tableHead, this.filterLevels, data['mergecols']);
    data['options']['rows'].forEach((row, rindex) => {
      const tableDataTR = this.renderer.createElement('tr');
      const tableDataTD = this.renderer.createElement('td');
      this.renderer.appendChild(tableDataTR, tableDataTD);
      this.renderer.appendChild(tableBody, tableDataTR);
      this.renderer.appendChild(tableDataTD, this.renderer.createText(row['v']));
      data['options']['data'].forEach(cell => {
        const tableDataTD = this.renderer.createElement('td');
        
        this.renderer.appendChild(tableDataTD, this.renderer.createText(cell[rindex]['v']));
        this.renderer.appendChild(tableDataTR, tableDataTD);
        
      })
      if (rindex == (data['options']['rows'].length - 1)) {
        const emptyTR = this.renderer.createElement('tr');
        this.renderer.appendChild(tableBody, emptyTR);
      }
    })  
    
    
  }

  drawDownloadTableHeaders(elmRef:HTMLElement, data:any, length:number){

    Object.keys(data).forEach(key =>  {
      const tableTR = this.renderer.createElement('tr');
      const tableTHEmpty = this.renderer.createElement('th');
      this.renderer.appendChild(tableTR, tableTHEmpty);
      this.renderer.appendChild(elmRef, tableTR);
      data[key].forEach(item => {
        const tableTH = this.renderer.createElement('th');
        this.renderer.appendChild(tableTR, tableTH);
        this.renderer.appendChild(tableTH, this.renderer.createText(item['name']));
        this.renderer.setAttribute(tableTH, 'colspan',item['mergecols'] + 1);
        // this.renderer.setAttribute(tableTH, 'rowspan',data[key]['mergerows']);
      });

    });
  }

  levelTraverser(obj:any,level){
    if(!this.filterLevels["level "+level]){
      this.filterLevels["level "+level] = [];
    }
    if(!this.filterLevels["option"]){
      this.filterLevels["option"] = [];
    }
    let nextLevel = level+1;
    Object.keys(obj).forEach(element => {
        let item = obj[element];
        item.name = element;
        if(item.type == 'option'){
          this.filterLevels["option"].push(item);
            let copy_item = Object.assign({}, item); ;
            copy_item.name = "";
            this.filterLevels["level "+level].push(copy_item);
        }
        else{
          this.filterLevels["level "+level].push(item);
        }
        if(item.options && Object.keys(item.options).length > 0){
          this.levelTraverser(item.options,nextLevel);
        }
    });  
  }

  getDownloadType(type){
    let body ={
      "type":"",
      "sheet_id":this.evService.selectedSheet['value']["sheet_id"],
    };
    switch (type.type) {
      case "opened-kpi":
        // if (this.evService.isdataTableToplineMapFound) {
        //   body["type"] = "kpi";
        //   body["kpi_id"] = [];
        //   this.opendKpi.forEach(key =>{
        //     body["kpi_id"].push(this.evService.selectedSheet['value']['kpis'][key]["kpi_id"])
        //   });
        //   this.downloadFile(body)
        // }else{
        //   let data = {};
        //   this.opendKpi.forEach(key =>{
        //     data[key] = this.evService.selectedSheet['value']['kpis'][key]
        //   });
        //   if (Object.keys(data).length) {
        //     this.drawDownloadTable(data);
        //     setTimeout(()=>{this.download()},200);
        //   }
        // }
        body["type"] = "kpi";
        body["kpi_id"] = [];
        this.opendKpi.forEach(key =>{
          body["kpi_id"].push(this.evService.selectedSheet['value']['kpis'][key]["kpi_id"])
        });
        this.downloadFile(body)
        break;
      case "opened-tab":
        // if (this.evService.isdataTableToplineMapFound) {
        //   body["type"] = "tab";
        //   this.downloadFile(body)
        // }else{
        //   let tableData = this.evService.selectedSheet['value']['kpis'];
        //   this.drawDownloadTable(tableData);
        //   setTimeout(()=>{this.download()},200);
        // }
        body["type"] = "tab";
        this.downloadFile(body);
        break;
      default:
        break;
    }
  }

  download(){
    this.excelService.exportTableAsExcelFile(this.downloadTableRef,'excelview');
  }

  downloadFile(body){
    // console.log("body is ===> ",body);
    this.repoService.downloadFile(body).subscribe(
      result =>{
        if (result["status"] == 1) {
          let url = result['url'];
          let ahref:HTMLElement = document.getElementById('downloadFIleURL');
          // let url ="https://eagle-staging1.crownit.in/kpifilesdataTable123_topline6490_1577_sheet_4380_1674039574186.xlsx"
          // console.log("url is ===> ",url);
          ahref.setAttribute('href', url);
          ahref.setAttribute('target', '_blank');
          ahref.setAttribute('download', this.evService.selectedSheet["key"].replace(/\ /g,"_")+'.xlsx');
          // ahref.setAttribute('download', this.reportService.fileName+'.'+this.reportService.fileType);
          ahref.click();
        }else if(result["status"] == 4){
          this.notifier.notify("error",result['message']);
          this.sidePanelService.afterLoginNavigate();
        }else{
          this.notifier.notify("error","Something went wrong!")
        }
      },error =>{
        console.log(error)
      }
    )
    
  }



}
